<script>
import Header from "../components/header/Header.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";
import Modals from "../components/Modals.svelte";
import Footer from "../components/Footer.svelte";

let complaint = {
  company: "DALOC AB",
  address: "Industrigatan 7",
  postal: "545 31 Töreboda",
  articlenumber: "108080",
  product: "Spanjolett S1151 (865) L= 388M",
  ammount: "1",
  recammount: "1",
  price: "240",
  sum: "240",
};
</script>

<div class="container" id="wrapper">
  <TopbarSignedIn />
  <Header />
  <div class="complaint-five">
    <div class="row">
      <div class="col-xs-12">
        <div class="row fill-white">
          <div class="col-xs-12">
            <div id="content" class="main-content">
              <!-- contenttop -->
              <div class="row">
                <div class="col-xs-12">
                  <ul class="breadcrumb">
                    <li class="active">Min sida</li>
                    <li>
                      <a href="/shop/IboxServlet?p=IXS850">Reklamationer</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="padd">
                <!-- Workflow -->
                <div class="workflow">
                  <ul class="breadcrumb breadcrumb-secondary mt-md">
                    <li><a href="#"><span>1. Ärende</span></a></li>
                    <li><a href="#"><span>2. Rader</span></a></li>
                    <li><a href="#"><span>3. Anmärkningar</span></a></li>
                    <li><a href="#"><span>4. Leveransadress</span></a></li>
                    <li class="active-step"><span>5. Boka</span></li>
                    <li><a href="#"><span>6. Kvitto</span></a></li>
                  </ul>
                </div>
                <div class="clear"></div>

                <!-- Info -->
                <div class="row">
                  <div class="col-xs-12 mt-sm">
                    <h2>Ny reklamation / retur</h2>
                  </div>
                </div>
                <div class="border-frame col-md-12">
                  <div class="delivery-address col-md-6">
                    <h4>Leveransadress</h4>
                    <p class="company-name">{complaint.company}</p>
                    <p>{complaint.address}</p>
                    <p>{complaint.postal}</p>
                  </div>
                  <div class="return-address col-md-6">
                    <h4>Returadress</h4>
                    <p class="company-name">Göthes Industribeslag AB</p>
                    <p>Roxnäsvägen 14</p>
                    <p>791 44 Falun</p>
                  </div>
                  <div class="products">
                    <h4>Produkter att reklamera</h4>
                    <form
                      class="full cart"
                      action="/shop/IboxServlet"
                      method="post"
                      accept-charset="utf-8"
                      name="form"
                      id="form"
                    >
                      <div class="table-responsive">
                        <table class="table table-condensed table-striped">
                          <thead class="table-header-inverse">
                            <tr>
                              <th class="first">Artikelnr</th>
                              <th>Benämning</th>
                              <th>Antal</th>
                              <th>Rekl. antal</th>
                              <th>Pris</th>
                              <th>Belopp</th>
                              <th width="100">Anmärkning</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr valign="top" class="odd">
                              <td class="first">{complaint.articlenumber}</td>
                              <td><strong>{complaint.product}</strong></td>
                              <td>{complaint.ammount} st</td>
                              <td>{complaint.recammount} st</td>

                              <td>{complaint.price} SEK</td>
                              <td>{complaint.sum} SEK</td>
                              <td></td>
                            </tr>
                            <tr valign="top" class="even">
                              <td colspan="8" class="first">
                                Underleverans 1 st, leverera resterande.
                              </td>
                            </tr>

                            <tr valign="top" class="odd">
                              <td class="first">{complaint.articlenumber}</td>
                              <td><strong>{complaint.product}</strong></td>
                              <td>{complaint.ammount} st</td>
                              <td>{complaint.recammount} st</td>
                              <td>{complaint.price} SEK</td>
                              <td>{complaint.sum} SEK</td>
                              <td></td>
                            </tr>
                            <tr valign="top" class="even">
                              <td colspan="8" class="first">
                                Underleverans 1 st, krediteras.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form>
                    <div class="form-checkbox">
                      <input
                        type="checkbox"
                        id="check"
                        class="inputCheckBox"
                        value="J"
                        name="CHK8"
                        checked="checked"
                      />
                      <label for="check">
                        Jag godkänner
                        <a
                          href="/public/documents/Reklamationreturvillkor.pdf"
                          target="_blank"
                        >villkoren för reklamation / retur</a>.
                      </label>
                    </div>
                    <button
                      class="button btn btn-primary btn-lg"
                      type="submit"
                    ><span>Boka reklamation</span></button>
                  </div>
                </div>
                <!--padd -->
              </div>
            </div>
            <div class="col-xs-12 col-sm-3 sidebar-secondary"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<Footer />
<Modals />
